module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "Epigraph",
      "title": "Epigraph"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“The tops of mountains are among the unfinished parts of the globe, whither it is a slight insult to the gods to climb and pry into their secrets, and try their effect on our humanity. Only daring and insolent men, perchance, go there.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphbyline"
  }, [_vm._v("—Henry David Thoreau")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69688d10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Epigraph.vue
// module id = 72
// module chunks = 0